<template>
  <div class="btn-group change-lang" role="group" aria-label="Button group with nested dropdown">
    <div class="btn-group" role="group" :class="{ show }">
      <button
        id="btnGroupDrop1"
        type="button"
        class="dropdown-toggle btn-lang"
        data-toggle="dropdown"
        aria-haspopup="true"
        :aria-expanded="`show`"
        @click.prevent="toggle"
      >
        <span :class="languages.selected.value">
          <small class="lang-hidden">{{ languages.selected.label }}</small>
        </span>
      </button>

      <div class="dropdown-menu" aria-labelledby="btnGroupDrop1" :class="{ show }">
        <a
          v-for="lang in availableLanguages"
          :key="lang.value"
          class="dropdown-item"
          href="#"
          @click="changeLang(lang.value)"
        >
          <span :class="lang.value">{{ lang.label }}</span>
        </a>
      </div>
    </div>
  </div>
</template>

<script>
import { Storage } from '@/enums/storage.enum';
import { loadLanguageAsync } from '@/i18n';
import { lagnuagesMixin } from '@/mixins/languages';
import { notificationsMixin } from '@/mixins/notifications';
import { profileResource } from '@/resources/profile.resource';
import { getProfileId } from '@/utils/profile';

// @vuese
// Dropdown ze zmianą języka
// @group Layout
export default {
  name: 'ChangeLanguage',
  mixins: [notificationsMixin, lagnuagesMixin],
  data() {
    return {
      show: false
    };
  },
  computed: {
    availableLanguages() {
      return this.languages.list.filter(lang => lang.value !== this.languages.selected.value);
    }
  },
  methods: {
    // @vuese
    // Przełącza widoczność menu
    toggle() {
      this.show = !this.show;
    },

    // @vuese
    // Zmienia język interfejsu
    // @arg `value` - kod języka
    changeLang(value) {
      this.setLang(value);
      this.toggle();
    }
  },
  mounted() {
    const lang = localStorage.getItem(Storage.LANG) || 'pl';

    loadLanguageAsync(lang);
    this.$set(this.languages, 'selected', this.getLabel(lang));
  }
};
</script>

<style>
.change-lang .dropdown-menu {
  min-width: 105%;
  border-radius: 0;
  left: -5px;
  background-color: #f7f9fa;
}
.change-lang .dropdown-menu .dropdown-item {
  padding-left: 12px;
}
.change-lang span {
  text-transform: uppercase;
  font-size: 1rem;
  line-height: 150%;
  padding-left: 30px;
  background-position: left 50%;
  background-repeat: no-repeat;
  background-image: url(/img/lang/pl.png);
}
.change-lang span.en {
  background-image: url(/img/lang/en.png);
}
.change-lang span.de {
  background-image: url(/img/lang/de.png);
}
.btn-lang {
  background-color: transparent;
  border: none;
  color: white;
  text-transform: uppercase;
}
.lang-hidden {
  display: none;
}
@media (min-width: 768px) {
  .lang-hidden {
    display: inline-block;
  }
}
.dropdown-toggle:after,
.dropleft .dropdown-toggle:before {
  content: '\f0d7' !important;
}
.change-lang .dropdown-item span {
  font-size: 0.8rem;
}
</style>
